import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyformat' })
export class CurrencyFormatPipe implements PipeTransform {
    transform(value: number, args: string[]): any {
        if (!value) {
            return value
        };

        return this.convert(Math.round(value));

    }
    convert(value: any) {
        if (value >= 1000000000) {
            value = (value / 1000000000);
            value = Math.round(value);
            value += 'B';
        } else if (value >= 1000000) {
            value = (value / 1000000);
            value = Math.round(value);
            value += 'M';
        } else if (value >= 1000) {
            value = (value / 1000);
            value = Math.round(value);
            value += 'K';
        }
        return value;
    }
};



// WEBPACK FOOTER //
// ./src/app/pipes/app.currency.pipe.ts